import lazyLoading from './lazyLoading'

export default {
  name: 'manualInvoice',
  path: '/manualInvoice',
  component: lazyLoading('manualInvoice/ManualInvoice'),
  meta: {
    default: false,
    title: 'Factura Manual',
    iconClass: 'fa fa-money',
    requiresAuth: true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/manualInvoice.js